import React, { useState, useEffect } from "react";
import {
  Box,
  makeStyles,
  Typography,
  Button,
  Grid,
  LinearProgress,
} from "@material-ui/core";
import CustomModal from "../Modals/CustomModal";
import ProjectDetailsModal from "../Modals/ProjectDetailsModal";
import { useDispatch, useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  StepContainer: {
    background: "#FFFFFF",

    boxShadow: "4px 4px 30px rgba(34, 43, 69, 0.08)",
    borderRadius: "8px",

    padding: "3rem",
    minHeight: "65rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  pageHeading: {
    fontWeight: "700",
    fontSize: "2.4rem",
    lineHeight: "3.2rem",
    marginBottom: "3rem",
  },

  container: {
    background: "#FFFFFF",
    boxShadow: "0px 4px 16px rgba(34, 43, 69, 0.12)",
    borderRadius: "8px",
    width: "35rem",
    overflow: "hidden",
    marginBottom: "3rem",
    marginRight: "3rem",
  },

  poolLabel: {
    fontWeight: "400",
    fontSize: "1.2rem",
    lineHeight: "2.1rem",
    marginRight: "1.6rem",
  },
  poolLabelValue: {
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2.1rem",
  },

  poolDetailRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: "1.6rem",
  },

  poolFooter: {
    background: "#F5F7FA",
    padding: ".8rem 1.5rem",
  },

  poolHeader: {
    padding: "3rem 1.5rem",
  },

  barColor: {
    backgroundColor: "#1ED059",
  },

  barRoot: {
    height: "1rem",
    borderRadius: "8px",
  },
}));

const TokenPool = ({ onClick, data }) => {
  const classes = useStyles();

  const [progress, setProgress] = useState(10);
  const [posts, setPosts] = useState([]);

  function LinearProgressWithLabel(props) {
    return (
      <Box display="flex" alignItems="center">
        <Box width="100%" mr={1}>
          <LinearProgress
            variant="determinate"
            value={(data.investmentFilled / data.budget) * 100}
            style={{ backgroundColor: "#B2F2C6" }}
            classes={{ bar: classes.barColor, root: classes.barRoot }}
          />
        </Box>

        <Box minWidth={35}>
          <Typography variant="body2" color="textSecondary">{`${Math.round(
            (data.investmentFilled / data.budget) * 100
          )}%`}</Typography>
        </Box>
      </Box>
    );
  }

  useEffect(() => {
    if (data?.platforms[0]) {
      console.log("ssssssssss", data?.platforms[0][1]);
      setPosts(data?.platforms[0]);
    }
  }, [data]);

  return (
    <Box className={classes.container} onClick={onClick}>
      {/* {data?.map((data) => {
        return (
          <> */}
      <Box className={classes.poolHeader}>
        <Typography className={classes.pageHeading}>
          {/* {data.projectName} */}
          {data?.projectId?.projectName}
        </Typography>

        <Box className={classes.poolDetailRow}>
          <Typography className={classes.poolLabel}>Platform</Typography>
          <Typography className={classes.poolLabelValue}>
            {posts[1]?.followers && "Twitter"}
            {"  "}
            {posts[2]?.followers && "Youtube"} {posts[3]?.followers && "Tiktok"}{" "}
            {posts[4]?.followers && "Instagram "}
            {!posts[1]?.followers &&
              !posts[2]?.followers &&
              !posts[3]?.followers &&
              !posts[4]?.followers &&
              "No Posts"}
          </Typography>
        </Box>
        <Box className={classes.poolDetailRow}>
          <Typography className={classes.poolLabel}>Language</Typography>
          <Typography className={classes.poolLabelValue}>English</Typography>
        </Box>
        <Box className={classes.poolDetailRow}>
          <Typography className={classes.poolLabel}>Campaign Budget</Typography>
          <Typography className={classes.poolLabelValue}>
            {data.budget}
          </Typography>
        </Box>
        <Box className={classes.poolDetailRow}>
          <Typography className={classes.poolLabel}>
            Min / Max Allocation
          </Typography>
          <Typography className={classes.poolLabelValue}>
            {data.minAlloPerKOL} / {data.maxAlloPerKOL} USDT
          </Typography>
        </Box>
      </Box>
      <Box className={classes.poolFooter}>
        <Box marginBottom="1rem">
          <Typography className={classes.poolLabelValue}>
            Progress ({data.investmentFilled} / {data.budget}) USDT
          </Typography>
        </Box>

        <LinearProgressWithLabel />
      </Box>
      {/* </>
        );
      })} */}
    </Box>
  );
};

export default TokenPool;
